"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef, useState } from "react";
import { GroupDescriptionType } from "@/entities/IGroup";
import { ApiGroupDescription } from "@/generated/models/ApiGroupDescription";
import { ApiGroupFilterDirection } from "@/generated/models/ApiGroupFilterDirection";
import { ApiGroupFull } from "@/generated/models/ApiGroupFull";
import GroupCardConfig from "./GroupCardConfig";
export interface GroupCardConfigProps {
  readonly key: GroupDescriptionType;
  readonly value: string;
}
export default function GroupCardConfigs(t0) {
  const $ = _c(23);
  const {
    group
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      [ApiGroupFilterDirection.Received]: "from",
      [ApiGroupFilterDirection.Sent]: "to"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const directionLabels = t1;
  const getMinMaxValue = _temp;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = t3 => {
      const {
        identity,
        direction
      } = t3;
      if (!identity) {
        return null;
      }
      return `${direction ? directionLabels[direction] : ""} identity: ${identity}`;
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const getIdentityValue = t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = tdh => {
      const value = getMinMaxValue({
        min: tdh.min,
        max: tdh.max
      });
      if (!value) {
        return null;
      }
      return {
        key: GroupDescriptionType.TDH,
        value
      };
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const getTdhConfig = t3;
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = rep => {
      const value_0 = getMinMaxValue({
        min: rep.min,
        max: rep.max
      });
      const category = rep.category?.length ? `category: ${rep.category}` : null;
      const identity_0 = getIdentityValue({
        identity: rep.user_identity,
        direction: rep.direction
      });
      const parts = [value_0, category, identity_0].filter(Boolean);
      if (!parts.length) {
        return null;
      }
      return {
        key: GroupDescriptionType.REP,
        value: parts.join(", ")
      };
    };
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const getRepConfig = t4;
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = cic => {
      const value_1 = getMinMaxValue({
        min: cic.min,
        max: cic.max
      });
      const identity_1 = getIdentityValue({
        identity: cic.user_identity,
        direction: cic.direction
      });
      const parts_0 = [value_1, identity_1].filter(Boolean);
      if (!parts_0.length) {
        return null;
      }
      return {
        key: GroupDescriptionType.NIC,
        value: parts_0.join(", ")
      };
    };
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  const getCicConfig = t5;
  let t6;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = level => {
      const value_2 = getMinMaxValue({
        min: level.min,
        max: level.max
      });
      if (!value_2) {
        return null;
      }
      return {
        key: GroupDescriptionType.LEVEL,
        value: value_2
      };
    };
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  const getLevelConfig = t6;
  const getWalletsConfig = _temp2;
  let t7;
  if ($[6] !== group) {
    const getConfigs = () => {
      if (!group) {
        return [{
          key: GroupDescriptionType.WALLETS,
          value: "0"
        }];
      }
      const configs = [];
      const {
        tdh: tdh_0,
        rep: rep_0,
        cic: cic_0,
        level: level_0,
        identity_group_identities_count
      } = group.group;
      const tdhConfig = getTdhConfig(tdh_0);
      const repConfig = getRepConfig(rep_0);
      const cicConfig = getCicConfig(cic_0);
      const levelConfig = getLevelConfig(level_0);
      const walletsConfig = getWalletsConfig(identity_group_identities_count);
      if (tdhConfig) {
        configs.push(tdhConfig);
      }
      if (repConfig) {
        configs.push(repConfig);
      }
      if (cicConfig) {
        configs.push(cicConfig);
      }
      if (levelConfig) {
        configs.push(levelConfig);
      }
      if (walletsConfig) {
        configs.push(walletsConfig);
      }
      return configs;
    };
    t7 = getConfigs();
    $[6] = group;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  const configs_0 = t7;
  const [isLeftHidden, setIsLeftHidden] = useState(false);
  const [isRightHidden, setIsRightHidden] = useState(true);
  const containerRef = useRef(null);
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = () => {
      const container = containerRef.current;
      if (container) {
        const {
          scrollLeft,
          scrollWidth,
          clientWidth
        } = container;
        setIsLeftHidden(scrollLeft > 0);
        setIsRightHidden(scrollLeft < scrollWidth - clientWidth);
      }
    };
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  const checkForHiddenContent = t8;
  let t9;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = direction_0 => {
      const container_0 = containerRef.current;
      if (container_0) {
        const scrollAmount = direction_0 === "left" ? -200 : 200;
        container_0.scrollBy({
          left: scrollAmount,
          behavior: "smooth"
        });
      }
    };
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  const scrollContainer = t9;
  let t10;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = () => {
      checkForHiddenContent();
      window.addEventListener("resize", checkForHiddenContent);
      return () => window.removeEventListener("resize", checkForHiddenContent);
    };
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  let t11;
  if ($[11] !== configs_0) {
    t11 = [configs_0];
    $[11] = configs_0;
    $[12] = t11;
  } else {
    t11 = $[12];
  }
  useEffect(t10, t11);
  let t12;
  if ($[13] !== isLeftHidden) {
    t12 = isLeftHidden && <button onClick={e => {
      e.stopPropagation();
      scrollContainer("left");
    }} aria-label="Scroll left" className="tw-absolute tw-left-0 tw-top-1/2 tw-z-30 tw-inline-flex tw-border tw-border-solid tw-border-white/ tw-h-7 tw-w-7 tw-translate-y-[-50%] -tw-translate-x-3 tw-items-center tw-justify-center tw-rounded-full tw-bg-iron-800 tw-text-white tw-transition tw-duration-200 tw-ease-out focus-visible:tw-outline focus-visible:tw-outline-2 focus-visible:tw-outline-offset-2 focus-visible:tw-outline-primary-500 desktop-hover:hover:tw-bg-white/10"><svg className="tw-h-4 tw-w-4 tw-text-iron-200 desktop-hover:hover:tw-text-white tw-rotate-90 tw-transition tw-duration-200 tw-ease-out" viewBox="0 0 24 24" aria-hidden="true" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 9L12 15L18 9" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" /></svg></button>;
    $[13] = isLeftHidden;
    $[14] = t12;
  } else {
    t12 = $[14];
  }
  let t13;
  if ($[15] !== configs_0) {
    t13 = <div className="tw-flex tw-items-center tw-gap-x-4 tw-gap-y-2 tw-overflow-x-auto tw-py-0.5 horizontal-menu-hide-scrollbar" ref={containerRef} onScroll={checkForHiddenContent}>{configs_0.map(_temp3)}</div>;
    $[15] = configs_0;
    $[16] = t13;
  } else {
    t13 = $[16];
  }
  let t14;
  if ($[17] !== isRightHidden) {
    t14 = isRightHidden && <button onClick={e_0 => {
      e_0.stopPropagation();
      scrollContainer("right");
    }} aria-label="Scroll right" className="tw-absolute tw-right-0 tw-border tw-border-solid tw-border-white/5 tw-top-1/2 tw-z-30 tw-inline-flex tw-h-7 tw-w-7 tw-translate-y-[-50%] tw-translate-x-3 tw-items-center tw-justify-center tw-rounded-full tw-bg-iron-800 tw-text-white tw-transition tw-duration-200 tw-ease-out focus-visible:tw-outline focus-visible:tw-outline-2 focus-visible:tw-outline-offset-2 focus-visible:tw-outline-primary-500 desktop-hover:hover:tw-bg-white/10"><svg className="tw-h-4 tw-w-4 tw-text-iron-200 desktop-hover:hover:tw-text-white -tw-rotate-90 tw-transition tw-duration-200 tw-ease-out" viewBox="0 0 24 24" aria-hidden="true" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 9L12 15L18 9" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" /></svg></button>;
    $[17] = isRightHidden;
    $[18] = t14;
  } else {
    t14 = $[18];
  }
  let t15;
  if ($[19] !== t12 || $[20] !== t13 || $[21] !== t14) {
    t15 = <div className="tw-relative tw-flex tw-items-start tw-text-xs sm:tw-text-sm tw-text-iron-200"><div className="tw-overflow-x-hidden tw-w-full">{t12}{t13}{t14}</div></div>;
    $[19] = t12;
    $[20] = t13;
    $[21] = t14;
    $[22] = t15;
  } else {
    t15 = $[22];
  }
  return t15;
}
function _temp3(config) {
  return <GroupCardConfig config={config} key={config.key} />;
}
function _temp2(wallet_group_wallets_count) {
  if (!wallet_group_wallets_count) {
    return null;
  }
  return {
    key: GroupDescriptionType.WALLETS,
    value: `${wallet_group_wallets_count}`
  };
}
function _temp(t0) {
  const {
    min,
    max
  } = t0;
  if (min === null && max === null) {
    return null;
  }
  if (min === null) {
    return `<= ${max}`;
  }
  if (max === null) {
    return `>= ${min}`;
  }
  return `${min} - ${max}`;
}